import { createApp } from 'vue'
import './style.css'
import App from './App.vue'

window.createVueApp = async () => {
  const app = createApp(App)
  app.mount('#app')
}

window.createVueApp()
